export default __webpack_public_path__ + "static/media/pause_branco.b2db7fc1.svg";